registerComponent("sections/wa-faixa", function (component) {
/**
 * sections/wa-faixa — a faixa escura com a esfera dourada.
 *
 * A esfera é um `<video>` mudo em laço (o mesmo do cartão "Assistente ASA" da
 * home) e quem a faz sumir contra o fundo é o `mix-blend-mode` do CSS. Aqui
 * ficam a entrada do texto (`.entrada`, `_entrada.less` / ADR 0051) e o
 * carregamento da esfera quando a faixa se aproxima da tela — o markup traz
 * `data-src`, como o `_conta.js` (PERF-014, CWV-018).
 *
 * @param {HTMLElement} component - elemento raiz do componente
 * @param {Object} params
 */

if (Asa.movimentoPermitido()) {
    Asa.armarEntrada([component], '.entrada');
}

const video = component.querySelector('video[data-src]');

if (video) {
    const carregar = () => {
        video.src = video.dataset.src;

        // `play()` explícito: o `autoplay` foi avaliado sem fonte. A recusa
        // (aba oculta, economia de bateria) não é erro nosso.
        const tocando = video.play();

        if (tocando && typeof tocando.catch === 'function') {
            tocando.catch(() => {});
        }
    };

    if (!('IntersectionObserver' in window)) {
        carregar();
    } else {
        const observador = new IntersectionObserver((entradas) => {
            if (!entradas.some((entrada) => entrada.isIntersecting)) {
                return;
            }

            observador.disconnect();
            carregar();
        }, { rootMargin: '200px 0px' });

        observador.observe(video);
    }
}

});
